import {createSlice} from "@reduxjs/toolkit";

const authStateInit = {
    loggedIn: false,
    // Set when Auth0 tells us the session can only be recovered by signing in
    // again. Auth0's own isAuthenticated stays true in that situation, so the
    // UI needs this flag to know to offer Log in again.
    sessionExpired: false,
}

export const AuthSlice = createSlice({
    name: 'AuthSlice',
    initialState: authStateInit,
    reducers: {
        logout(state) {
            state.loggedIn = false;
            sessionStorage.removeItem('token');
        },
        loginSuccess(state, action) {
            state.loggedIn = true;
            state.sessionExpired = false;
            sessionStorage.setItem("token", action.payload.token);
        },
        sessionExpired(state) {
            state.loggedIn = false;
            state.sessionExpired = true;
            // Drop the stale token so the next callRemote asks Auth0 for a new
            // one rather than replaying a rejected one.
            sessionStorage.removeItem('token');
        },
    }
});
